export default __webpack_public_path__ + "static/media/ysd-004-setu_03.374d4470.jpg";